import * as React from 'react';
import { Box } from '@mui/material';
import UserQuizzesTable from '../components/UserQuizzesTable';

export default function QuizzesPage() {
    return (
        <Box sx={{ px: 3, py: 3 }}>
            <UserQuizzesTable showTitle />
        </Box>
    );
}
